import { ExpandMoreOutlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';

type AccordProps = {
  readonly title: string;
  readonly open?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly icon?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly children: any;
};

export const CustomAccordion = (props: AccordProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const Icon = props.icon;

  return (
    <div>
      <Box>
        <Accordion defaultExpanded={props.open ?? true}>
          <div>
            <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
              <Icon sx={{ color: 'blue' }} />
              &nbsp;
              <h3 style={{ margin: 0, marginLeft: 4 }}>{props.title}</h3>
            </AccordionSummary>
          </div>
          <AccordionDetails>{props.children}</AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
};
